import { network } from 'services/network';

export const uploadCardAssociatedDocument = (file: File) => {
    const data = new FormData();

    data.append('file', file);

    return network
        .post('api/bo/uploadCardAssociatedDocument', data, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((data) => {
            return data;
        });
};
